import {Component} from '@angular/core';

@Component({
    selector: 'app-shared-accordion',
    templateUrl: './shared-accordion.component.html',
    styleUrls: ['./shared-accordion.component.scss'],
    standalone: false
})
export class SharedAccordionComponent {
}
